@use "ui/styles/colors";
@use "ui/styles/fonts";
@use "ui/styles/fontStyles";
@use "ui/styles/sizes";
@use "ui/styles/effects";

.wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  white-space: nowrap;
  padding-block-start: sizes.$s6;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: sizes.$s3;
    margin-inline: sizes.$s6;
    padding-block-end: sizes.$s6;

    &.bottomLeftNav {
      margin-top: auto;
      padding-block-start: sizes.$s6;
    }

    li {
      border-radius: effects.$borderRadiusM;

      a {
        display: flex;
        align-items: center;
        height: sizes.$s8;
        gap: sizes.$s4;
        padding: 0 sizes.$s4;
        @include fontStyles.body2-book;

        svg {
          width: 1em;
          height: 1em;
          color: colors.$gray60;
        }
      }

      &:hover {
        background-color: colors.$gray30;

        a svg {
          color: initial;
        }
      }

      &.selected {
        background-color: colors.$gray30;

        a svg {
          color: initial;
        }
      }

      &.selected:hover {
        background-color: colors.$gray40;
      }
    }
  }
}
